module.exports = __webpack_public_path__ + "img/sangse.bef03ad8.jpg";